import loadable from '@loadable/component';
import { useDebugStore } from '@stores/debug';
import { ChangelogModal } from '@wegic/changelog-modal';
import { CreditCareModal } from '@/components/CreditCareModal';
import { isOnline } from '@/const/env';

const DebugPanel = loadable(() => import('./DebugPanel'));
const AppInfo = loadable(() => import('./AppInfo'));
const PaymentTestModal = loadable(() => import('./PaymentTestModal'));
const ABTestDebugPanel = loadable(() => import('../ABTest/DebugPanel'));

export function DebugTools() {
  const showChangelogModal = useDebugStore(state => state.showChangelogModal);
  const setShowChangelogModal = useDebugStore(state => state.setShowChangelogModal);
  const showCreditCareModal = useDebugStore(state => state.showCreditCareModal);
  const setShowCreditCareModal = useDebugStore(state => state.setShowCreditCareModal);
  const showABTestPanel = useDebugStore(state => state.showABTestPanel);

  return (
    <>
      <DebugPanel />
      <AppInfo />
      <PaymentTestModal />
      <ChangelogModal
        visible={showChangelogModal}
        onCancel={() => setShowChangelogModal(false)}
        onConfirm={() => setShowChangelogModal(false)}
        showDebugPanel
      />
      <CreditCareModal
        externalVisible={showCreditCareModal}
        onExternalClose={() => setShowCreditCareModal(false)}
      />
      {!isOnline && showABTestPanel && <ABTestDebugPanel />}
    </>
  );
}
